import { formatInReportingTimezone } from '../utils/localeFormatting';

const dateKey = date => date.toISOString().slice(0, 10);

const reportingCalendarDate = (now, reportingTimezone) => {
  const key =
    formatInReportingTimezone(now, 'yyyy-MM-dd', reportingTimezone) ||
    formatInReportingTimezone(now, 'yyyy-MM-dd', 'UTC');
  return new Date(`${key}T12:00:00Z`);
};

export const reportingDatePreset = (
  preset,
  { now = new Date(), reportingTimezone = 'UTC' } = {}
) => {
  const today = reportingCalendarDate(now, reportingTimezone);

  if (preset === 'today') {
    const todayKey = dateKey(today);
    return { start: todayKey, end: todayKey };
  }

  // "Últimos N dias" INCLUI hoje: um intervalo de 7 dias que termina ontem
  // esconderia justamente a venda que o usuário acabou de registrar.
  const lastDays = String(preset).match(/^last_(\d+)$/);
  if (lastDays) {
    const start = new Date(today);
    start.setUTCDate(today.getUTCDate() - (Number(lastDays[1]) - 1));
    return { start: dateKey(start), end: dateKey(today) };
  }

  // Mês corrente do calendário DA CONTA — perto da virada do mês o navegador
  // pode já estar noutro mês e mediria o período errado.
  if (preset === 'this_month') {
    const first = new Date(today);
    first.setUTCDate(1);
    return { start: dateKey(first), end: dateKey(today) };
  }

  if (preset === 'this_week') {
    const monday = new Date(today);
    const day = today.getUTCDay();
    monday.setUTCDate(today.getUTCDate() - (day === 0 ? 6 : day - 1));
    const sunday = new Date(monday);
    sunday.setUTCDate(monday.getUTCDate() + 6);
    return { start: dateKey(monday), end: dateKey(sunday) };
  }

  if (preset === 'overdue') {
    const yesterday = new Date(today);
    yesterday.setUTCDate(today.getUTCDate() - 1);
    return { start: null, end: dateKey(yesterday) };
  }

  return { start: null, end: null };
};
